import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgButtonMore = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	})
});
export default SvgButtonMore;
